import React, { forwardRef } from 'react'
import cn from 'classnames'
import InputMaskComponent from 'react-input-mask'
import s from './input-mask.module.css'
import type { InputMaskProps } from './types'

const InputMask = (props: InputMaskProps, ref: any) => {
  const {
    className,
    name,
    inputClassName,
    pure = false,
    mask,
    maskPlaceholder,
    label,
    touched,
    error,
    onChange,
    ...rest
  } = props

  // Handler para colar valores sem máscara
  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    let paste = e.clipboardData.getData('Text')
    paste = paste.replace(/\D/g, '') // remove tudo que não for número
    if (paste) {
      e.preventDefault()
      // Chama o onChange diretamente com o valor limpo
      if (onChange) {
        onChange({
          target: {
            value: paste,
            name,
          },
        } as any)
      } else {
        // fallback: insere o valor no input
        e.currentTarget.value = paste
      }
    }
  }

  if (pure) {
    return <input className={cn(s.input, inputClassName)} ref={ref} name={name} {...rest} />
  }

  return (
    <label htmlFor={name} className={cn(s.root, className)}>
      {label && <span className={s.label}>{label}</span>}
      <InputMaskComponent
        mask={mask}
        className={cn(s.input, inputClassName)}
        ref={ref}
        name={name}
        onPaste={handlePaste}
        onChange={onChange}
        {...rest}
      />
      <span className={s.alert} role="alert">
        {touched && error ? error : null}
      </span>
    </label>
  )
}

export default forwardRef(InputMask)
